import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '@/context/LanguageContext';

const useNoIndex = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, follow';
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);
};

const LegalNoticePage = () => {
  const { lang, t } = useLang();
  const navigate = useNavigate();
  useNoIndex();

  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };

  useEffect(() => {
    document.title = lang === 'fr'
      ? 'Mentions légales | Red House Residency'
      : 'Legal notice | Red House Residency';
  }, [lang]);

  const isFr = lang === 'fr';

  return (
    <main data-testid="legal-page" className="bg-background min-h-screen pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-5 md:px-10">
        <button
          type="button"
          onClick={handleBack}
          data-testid="back-button"
          className="text-sm text-[#555] hover:text-[#E92A3E] transition-colors mb-8"
        >
          {t('footer.back')}
        </button>

        <h1 className="font-heading text-4xl sm:text-5xl text-[#111] mb-12">
          {isFr ? 'Mentions légales' : 'Legal notice'}
        </h1>

        <div className="space-y-10 text-[#333] text-base leading-relaxed">
          <section>
            <h2 className="font-heading text-lg text-[#111] mb-3 uppercase tracking-wider">
              {isFr ? 'Éditeur du site' : 'Site editor'}
            </h2>
            <p>MUSE ME (RED HOUSE RECORDS)</p>
            <p>SAS</p>
            <p>5 rue Casimir Boirot, 51120 La Forestière</p>
            <p>SIREN : 498 484 112</p>
            <p>{isFr ? 'N° TVA intracommunautaire' : 'Intra-community VAT'} : FR50 498 484 112</p>
            <p>{isFr ? 'Directeur de la publication' : 'Publication director'} : Lucas Médus</p>
            <p>Email : <a href="mailto:studio@redhouse.co" className="text-[#E92A3E] hover:underline">studio@redhouse.co</a></p>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#111] mb-3 uppercase tracking-wider">
              {isFr ? 'Hébergement' : 'Hosting'}
            </h2>
            <p>IONOS SE</p>
            <p>7 Place de la Gare, 57200 Sarreguemines</p>
            <p>
              <a href="https://www.ionos.fr" target="_blank" rel="noopener noreferrer" className="text-[#E92A3E] hover:underline">
                https://www.ionos.fr
              </a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg text-[#111] mb-3 uppercase tracking-wider">
              {isFr ? 'Propriété intellectuelle' : 'Intellectual property'}
            </h2>
            <p>
              {isFr
                ? "L'ensemble du contenu de ce site est la propriété exclusive de MUSE ME (RED HOUSE RECORDS). Toute reproduction est interdite sans autorisation préalable."
                : 'All content of this site is the exclusive property of MUSE ME (RED HOUSE RECORDS). Any reproduction is prohibited without prior authorization.'}
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};

export default LegalNoticePage;
